import { useCollection } from '../hooks/useCollection';
import { useAuth } from '../hooks/useAuth';
import { formatCurrencyCompact } from '../utils/portfolioValue';

const initials = (username) => (username ? username.slice(0, 2).toUpperCase() : '?');

const StatTile = ({ label, value }) => (
  <div className="flex-1 rounded-xl bg-white/[0.07] py-2 text-center">
    <div className="text-white text-sm font-heading font-bold">{value}</div>
    <div className="text-white/40 text-[10px] uppercase tracking-wide mt-0.5">{label}</div>
  </div>
);

const MobileHeader = () => {
  const { getCollectionStats, packStats, getPortfolioValue, portfolioLoading } = useCollection();
  const { user } = useAuth();
  const stats = getCollectionStats();
  const portfolioValue = getPortfolioValue();

  return (
    <div className="md:hidden bg-navy-dark px-4 pt-3 pb-3">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <img src="/pockedex_logo.png" alt="Pockedex" className="w-[26px] h-[26px] rounded" />
          <span className="font-heading font-extrabold text-yellow text-lg">Pockedex</span>
        </div>
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow to-brick flex items-center justify-center text-navy-dark text-xs font-bold">
          {initials(user?.username)}
        </div>
      </div>
      <div className="flex gap-2.5">
        <StatTile label="Cards" value={stats.totalCards.toLocaleString()} />
        <StatTile label="Unique" value={stats.uniqueCards.toLocaleString()} />
        <StatTile label="Packs" value={packStats.totalPacks.toLocaleString()} />
        <StatTile label="Value" value={portfolioLoading ? '…' : formatCurrencyCompact(portfolioValue)} />
      </div>
    </div>
  );
};

export default MobileHeader;
